import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const fakeSubmissions = {
    "Accepted": 10,
    "Wrong_Answer": 15,
    "Time_Limit_Exceeded": 3,
    "Runtime_Error": 1,
    "Compilation_Error": 7
}

const mapBG = {
    "AC": "green",
    "WA": "red",
    "TLE": "orange",
    "Runtime_Error": "salmon",
    "Compilation_Error": "brown"
}

const SubmissionsChart = (props) => {
    // console.log(props.submissions);
    return (
        <div className="my-5" style={{height: "400px", width: "50%", margin: "0 auto"}}>
            <Doughnut
                data = {{
                    labels: props.submissions ? props.submissions?.map(sub => sub.verdict) : [],
                    datasets: [
                        {
                            label: "Submissions",
                            data: props.submissions ? props.submissions?.map(sub => sub.count) : [],
                            backgroundColor: props.submissions?.map(sub => mapBG[sub.verdict])
                        }
                    ],
                }}
                options = {{
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        title: {
                            display: true,
                            text: "Submissions",
                            font: {
                                size: 24
                            },
                            padding: {
                                bottom: 20
                            }
                        },
                        legend: {
                            position: 'bottom',
                        }
                    }
                }}
            />
        </div>
    );
}

export default SubmissionsChart;